import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
import { faqs } from '../../data/faqs';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-paper px-5 py-16 sm:py-24" data-id="element-169" data-mp="urkqgeleer84">
      <SectionHeader eyebrow="Frequently asked questions" title="Answers Before You Decide" data-id="element-170" data-mp="70f2td97uun9" />

      <div className="mx-auto mt-10 max-w-3xl divide-y divide-slate-200 overflow-hidden rounded-3xl bg-white ring-1 ring-slate-200" data-id="element-171" data-mp="22x1a7xj3hpa">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-172" data-mp="bzi3kli5yepf" data-mpi={i}>
              <h3 data-id="element-173" data-mp="c2e1waxxb5ee">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 hover:bg-paper sm:px-7" data-id="element-174" data-mp="1sejigc15bazo">
                  <span className="text-lg font-bold leading-snug text-ink" data-id="element-175" data-mp="ms0wahq6hiyk">{f.q}</span>
                  <PlusIcon className={`h-6 w-6 shrink-0 text-flame transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-176" data-mp="rrdntfrzve7h" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-177" data-mp="3v6srlz9s4rk6">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-178" data-mp="42km12ooyc4y">
                    <div className="space-y-3 px-5 pb-6 text-base leading-relaxed text-slate-700 sm:px-7" data-id="element-179" data-mp="3gj7q29sjz0ed">
                      {f.a.map(p => <p key={p} data-id="element-180" data-mp="nneklellqhxn">{p}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <CtaButton label="I’m Ready — Give Me Access" sub="One-time payment of $27 · Instant digital access" data-id="element-181" data-mp="xgveeilqnx1b" />
    </section>;
}